<p>add-customer-auto works!</p>
